module.exports = __webpack_public_path__ + "static/media/r265.658f5782.jpg";